import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const SpaceOperationsFragment: GraphQLTaggedNode = graphql`
	fragment SpaceOperationsFragment on Space {
		id
		operations {
			operation
			targetType
		}
	}
`;
